import { render } from "./HeaderMain.vue?vue&type=template&id=356c7852&scoped=true"
import script from "./HeaderMain.vue?vue&type=script&lang=js"
export * from "./HeaderMain.vue?vue&type=script&lang=js"

import "./HeaderMain.vue?vue&type=style&index=0&id=356c7852&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356c7852"]])

export default __exports__